<template>
  <vs-row id="targetReport" vs-type="flex" vs-w="12">
    <target-reviewer ref="targetReviewer" :target="selectedTarget" @close="selectedTarget = {}" />
    <vs-collapse class="w-full">
      <vs-collapse-item id="branchTargets" class="bg-white sale-box-shadow mb-2 mx-0 low-border-radius">
        <div slot="header">
          <span class="block w-full text-secondary text-smaller bold">
            Şube Hedefleri
          </span>
          <div class="w-full text-xsmall weight-500 text-dark">
            <span class="text-secondary text-xsmall bold mr-1">
              {{getMonth}}
            </span>
            Ayı,
            <span class="text-secondary text-xsmall bold ml-1 mr-1">
              {{selectedBranch.name}}
            </span>
            Şubesi için
            <span class="text-secondary text-xsmall bold ml-1 mr-1">
              {{branchTargets.length}}
            </span>
            hedef belirlendi.
          </div>
          <span v-if="daysToExpire != 0 && daysToExpire != null"
            class="block w-full text-danger text-xsmaller weight-600">
            {{daysToExpire + ' Gün Kaldı'}}
          </span>
          <span v-if="daysToExpire == 0 && daysToExpire != null"
            class="block w-full text-danger text-xsmaller weight-600">
            Gün Sonunda Bitiyor
          </span>
        </div>
        <vs-row vs-type="flex" vs-w="12">
          <vs-row vs-type="flex" vs-w="12" id="branchTargetList">
            <vs-row vs-type="flex" vs-w="12" class="branchTargetRow mb-2" vs-justify="center" vs-align="center"
              v-for="(target,index) in branchTargets" :key="index">
              <vs-col vs-type="flex" vs-w="1" vs-align="center" class="pr-1">
                <vs-button v-if="target.kind == 1" size="large" class="w-full targetTypeAvatar" type="filled"
                  color="rgb(60, 232, 196)" icon-pack="pickicon" icon="icon-products" />
                <vs-button v-if="target.kind == 2" size="large" class="w-full targetTypeAvatar" type="filled"
                  color="rgb(142, 224, 232)" icon-pack="pickicon" icon="icon-rich" />
                <vs-button v-if="target.kind == 3" size="large" class="w-full targetTypeAvatar" type="filled"
                  color="rgb(255, 159, 67)" icon-pack="feather" icon="icon-layers" />
              </vs-col>
              <vs-col vs-type="flex" vs-w="4" vs-align="center" class="px-1">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span v-if="target.kind == 1" class="text-dark text-xsmall bold">
                      Ürün Hedefi
                    </span>
                    <span v-if="target.kind == 2" class="text-dark text-xsmall bold">
                      Ciro Hedefi
                    </span>
                    <span v-if="target.kind == 3" class="text-dark text-xsmall bold">
                      Kategori Hedefi
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span v-if="target.kind == 1" class="text-secondary text-xsmaller weight-600">
                      {{target.targetQuantity + ' Adet ' + (target.product ? target.product.name : '')}}
                    </span>
                    <span v-if="target.kind == 2" class="text-secondary text-xsmaller weight-600">
                      {{$toCurrency(target.targetQuantity)}}
                    </span>
                    <span v-if="target.kind == 3" class="text-secondary text-xsmaller weight-600">
                      {{target.targetQuantity + ' Adet ' + (target.category ? target.category.name : '')}}
                    </span>
                  </vs-row>
                </vs-row>
              </vs-col>
              <vs-col vs-type="flex" vs-w="7" vs-align="center" class="px-1">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-progress :percent="target.targetQuantity > 0 ? (target.targetProcess * 100 / target.targetQuantity) : 0"
                      :color="target.kind == 3 ? 'rgb(255, 159, 67)' : (target.kind == 2 ? 'rgb(142, 224, 232)' : 'rgb(60, 232, 196)')">
                    </vs-progress>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start">
                      <span v-if="target.kind == 1 || target.kind == 3" class="text-secondary bold text-xsmall">
                        {{target.targetProcess + ' Adet'}}
                      </span>
                      <span v-if="target.kind == 2" class="text-secondary bold text-xsmall">
                        {{$toCurrency(target.targetProcess)}}
                      </span>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end">
                      <span v-if="target.kind == 1 || target.kind == 3" class="text-secondary bold text-xsmall">
                        {{target.targetQuantity + ' Adet'}}
                      </span>
                      <span v-if="target.kind == 2" class="text-secondary bold text-xsmall">
                        {{$toCurrency(target.targetQuantity)}}
                      </span>
                    </vs-col>
                  </vs-row>
                </vs-row>
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-row>
      </vs-collapse-item>
      <vs-collapse-item id="personalTargets" class="bg-white sale-box-shadow mb-2 mx-0 low-border-radius">
        <div slot="header">
          <span class="block w-full text-secondary text-smaller bold">
            Personel Hedefleri
          </span>
          <div class="w-full text-xsmall weight-500 text-dark">
            <span class="text-secondary text-xsmall bold mr-1">
              {{getMonth}}
            </span>
            Ayı,
            <span class="text-secondary text-xsmall bold ml-1 mr-1">
              {{selectedBranch.name}}
            </span>
            Personelleri için
            <span class=" text-secondary text-xsmall bold ml-1 mr-1">
              {{personalTargets.length}}
            </span>
            hedef belirlendi.
          </div>
          <span v-if="daysToExpire != 0 && daysToExpire != null"
            class="block w-full text-danger text-xsmaller weight-600">
            {{daysToExpire + ' Gün Kaldı'}}
          </span>
          <span v-if="daysToExpire == 0 && daysToExpire != null"
            class="block w-full text-danger text-xsmaller weight-600">
            Gün Sonunda Bitiyor
          </span>
        </div>
        <vs-row vs-type="flex" vs-w="12">
          <vs-row vs-type="flex" vs-w="12" id="personalTargetList">
            <div @click="openTargetReviewer(target)" class="d-flex vs-row w-full personalTargetRow mb-2"
              vs-justify="center" vs-align="center" v-for="(target,index) in personalTargets" :key="index">
              <vs-col vs-type="flex" vs-w="1" vs-align="center" class="pr-1">
                <vs-button v-if="target.kind == 1" size="large" class="w-full targetTypeAvatar" type="filled"
                  color="rgb(60, 232, 196)" icon-pack="pickicon" icon="icon-products" />
                <vs-button v-if="target.kind == 2" size="large" class="w-full targetTypeAvatar" type="filled"
                  color="rgb(142, 224, 232)" icon-pack="pickicon" icon="icon-rich" />
                <vs-button v-if="target.kind == 3" size="large" class="w-full targetTypeAvatar" type="filled"
                  color="rgb(255, 159, 67)" icon-pack="feather" icon="icon-layers" />
              </vs-col>
              <vs-col vs-type="flex" vs-w="3" vs-align="center" class="px-1">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span v-if="target.kind == 1" class="text-dark text-xsmall bold">
                      Ürün Hedefi
                    </span>
                    <span v-if="target.kind == 2" class="text-dark text-xsmall bold">
                      Ciro Hedefi
                    </span>
                    <span v-if="target.kind == 3" class="text-dark text-xsmall bold">
                      Kategori Hedefi
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span v-if="target.kind == 1" class="text-secondary text-xsmaller weight-600">
                      {{target.targetQuantity + ' Adet ' + (target.product ? target.product.name : '')}}
                    </span>
                    <span v-if="target.kind == 2" class="text-secondary text-xsmaller weight-600">
                      {{$toCurrency(target.targetQuantity)}}
                    </span>
                    <span v-if="target.kind == 3" class="text-secondary text-xsmaller weight-600">
                      {{target.targetQuantity + ' Adet ' + (target.category ? target.category.name : '')}}
                    </span>
                  </vs-row>
                </vs-row>
              </vs-col>
              <vs-col vs-type="flex" vs-w="7" vs-align="center" class="px-1">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-progress :percent="target.targetProcess * 100 / target.targetPersonals.length"
                      :color="target.kind == 2 ? 'rgb(142, 224, 232)' : 'rgb(60, 232, 196)'">
                    </vs-progress>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-col v-if="target.status == 'InProgress'" vs-type="flex" vs-w="8" vs-justify="flex-start">
                      <span class="text-secondary bold text-xsmall">
                        {{target.targetProcess + ' Personel Tamamlamış'}}
                      </span>
                    </vs-col>
                    <vs-col v-if="target.status == 'InProgress'" vs-type="flex" vs-w="4" vs-justify="flex-end">
                      <span class="text-secondary bold text-xsmall">
                        {{target.targetPersonals.length + ' Personel'}}
                      </span>
                    </vs-col>
                    <vs-col v-if="target.status == 'Finished'" vs-type="flex" vs-w="12" vs-justify="flex-end">
                      <span class="w-full text-center text-success bold text-smaller">
                        Tüm Personel({{target.targetPersonals.length}}) Hedefe Ulaştı !
                      </span>
                    </vs-col>
                  </vs-row>
                </vs-row>
              </vs-col>
            </div>
          </vs-row>
        </vs-row>
      </vs-collapse-item>
    </vs-collapse>
  </vs-row>
</template>

<script>
  import TargetReviewer from "../Target/TargetReviewer.vue";
  export default {
    props: {
      reportData: {
        type: Array,
        required: true
      },
      selectedBranch: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        selectedTarget: {}
      }
    },
    components: {
      TargetReviewer
    },
    methods: {
      openTargetReviewer(target) {
        this.selectedTarget = target;
        this.$refs.targetReviewer.isActive = true;
      },
    },
    computed: {
      getMonth() {
        return this.$months()[this.$now.date().getMonth()].name;
      },
      branchTargets() {
        return this.reportData.filter(x => x.type == 1);
      },
      personalTargets() {
        return this.reportData.filter(x => x.type == 2);
      },
      daysToExpire() {
        var today = this.$now.date();
        var totalDays = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
        return totalDays - today.getDate();
      }
    }
  }

</script>

<style>
  #targetReport .vs-collapse {
    padding: 0 !important;
  }

</style>
